import { useClientSideSettingsStore } from '@/stores/useClientSideSettingsStore';
import { usePhoneStore } from '@/stores/usePhoneStore';
import { useRouter } from 'vue-router';
import { RouteName } from '@/router/routes';
import { removeUnnecessaryCharsFromNumber } from '@/utils/numberUtils';

export const initRequestCallConfig = () => {
  const $clientSetting = useClientSideSettingsStore();
  const $phoneStore = usePhoneStore();
  const $router = useRouter();

  const dialPhoneNumber = (number: string) => {
    $router.push({ name: RouteName.Phone, query: { number: number } });
  };

  window.wtgPhoneApi.onRequestCall((payload: string[]) => {
    const number = payload?.[0] ?? '';
    const normalizedPhoneNumber = removeUnnecessaryCharsFromNumber(number);

    if (!normalizedPhoneNumber) {
      return;
    }

    if ($clientSetting._settings.focusOnShortcut) {
      window.wtgPhoneApi.showWindow();
    }

    if ($clientSetting._settings.callOnShortcut) {
      const call = $phoneStore.call(normalizedPhoneNumber);
      if (call !== null) {
        $router.push({ name: RouteName.Call, params: { callid: call.callId } });
        return;
      }
    }

    dialPhoneNumber(normalizedPhoneNumber);
  });
};
